const authEndPoints = {
    login: '/auth/login',
    refreshToken: '/auth/refreshToken'
}
const userEndPoints = {
    getAll: '/user/all',
    postUser: '/user',
    updateUser: '/user/{0}',
    activateUserById: '/user/{0}/activate',
    deActivateUserById: '/user/{0}/deactivate',
    getPhone:'/user/{0}/phone',
    postPhone:'/user/{0}/phone',
    updatePhone:'/user/{0}/phone/{1}',
}
const groupsEndPoints = {
    getAll: '/group/all',
    addGroup: '/group',
    updateGroupById: '/group/{0}',
    activateGroupById: '/group/{0}/activate',
    deActivateGroupById: '/group/{0}/deactivate',
    getGroupById: '/group/{0}'
}

const merchantsEndPoints = {
    getMerchantByGroupID: '/merchant',
    getMerchantByMerchantId: '/merchant/{0}/{1}',
    activateMerchantById: '/merchant/activate',
    deActivateMerchantById: '/merchant/deactivate',
    addEditMerchant: '/merchant'
}

const profilesEndPoints = {
    getAll: '/profile/all',
    getProfileById: '/profile/{0}',
    postProfile: '/profile',
    updateProfile: '/profile/{0}',
    activateProfileById: '/profile/{0}/activate',
    deActivateProfileById: '/profile/{0}/deactivate',
    getProfilePermissionsListById: '/profile/{0}/permission/list',
    updateProfilePermissionsListById: '/profile/{0}/permission/list',
    getAllRoutes: '/route/all'
}

const cardholdersEndPoints = {
    getAll: '/cardholder/all',
    getCardHolderByID: '/cardholder/{0}',
    getCardholderAddressById: '/cardholder/{0}/address',
    addCardholderAddress: '/cardholder/{0}/address',
    updateCardholderAddress: '/cardholder/{0}/address/{1}',
    getCardholderPhoneById: '/cardholder/{0}/phone',
    addCardholderPhone: '/cardholder/{0}/phone',
    updateCardholderPhone: '/cardholder/{0}/phone/{1}',
    getCardholderEmailById: '/cardholder/{0}/email',
    addCardholderEmail: '/cardholder/{0}/email',
    updateCardholderEmail: '/cardholder/{0}/email/{1}',
    getOpenBalanceByCardId: '/balance/{0}/open',
    getClosedBalanceByCardId: '/balance/{0}/closed',
    cardSuspendOpen: '/card/{0}/suspend/{1}/open',
    cardSuspendClosed: '/card/{0}/suspend/{1}/closed',
    getCardholderOpenLoopTransaction: 'report/transaction/{0}/{1}/{2}/{3}',  //report/transaction/{offset}/{rows}/{initDate}/{EndDate}
    changeStatusOfCard: '/card/{0}/status',
    allCardHolderById: '/card/cardholder/{0}/all',
    getCardInfoByCardId: '/card/{0}',
    getLastStartup:'/cardholder/{0}/lastStartup',
}
const promotionsEndPoints = {
    getAll: '/Promotion',
    activatePromotionById: '/Promotion/activate/{0}',
    postPromotion: '/Promotion',
    updatePromotion: '/Promotion',
    deActivatePromotionById: '/Promotion/deactivate/{0}',
    getPromotionById: '/Promotion/ById/{0}'
}
const catalogsEndPoints = {
    getAllCountry: '/country',
    getAllTelephoneType: '/telephoneType',
    getStates: '/state'
}
const programEndPoints = {
    getAll: "/program/all",
}
export {
    authEndPoints,
    userEndPoints,
    groupsEndPoints,
    merchantsEndPoints,
    profilesEndPoints,
    cardholdersEndPoints,
    promotionsEndPoints,
    catalogsEndPoints,
    programEndPoints
}